import PaypalAdd from './paypal-add';

export default PaypalAdd;
